module.exports = __webpack_public_path__ + "static/matthew-banks-resume-5-11-2021-0b67f0de2fadf4dbfb6050a5a47d0a8a.pdf";